$R.addLang('fr', {
    'custom_list_name': 'Liste',
    'custom_list_list1': 'Liste à puces',
    'custom_list_list2': 'Liste à flèches'
});